<template lang="html">
  <div class="loader">
    <h1>{{displayPercentage}}</h1>
    <h2>Percent</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      animationDuration: 500,
      animationStart: -1,
      cachedNumber: null,
      displayPercentage: this.percentage < 100 ? this.percentage < 10 ? `00${this.percentage}` : `0${this.percentage}` : this.percentage, // eslint-disable-line no-nested-ternary
    };
  },
  methods: {
    animate() {
      if (this.animationStart < 0) this.animationStart = Date.now();
      if (this.cachedNumber === null) this.cachedNumber = Number.parseInt(this.displayPercentage, 10);
      const time = Math.min((Date.now() - this.animationStart) / this.animationDuration, 1);
      const easedTime = time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;

      const result = Math.round(easedTime * (this.percentage - this.cachedNumber) + this.cachedNumber);
      switch (true) {
        case (result < 10):
          this.displayPercentage = `00${result}`;
          break;
        case (result < 100):
          this.displayPercentage = `0${result}`;
          break;
        default:
          this.displayPercentage = result;
      }

      if (time < 1) window.requestAnimationFrame(this.animate);
      else {
        this.animationStart = -1;
        this.cachedNumber = null;
      }
    },
  },
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    percentage() {
      this.animate();
    },
  },
};
</script>

<style lang="stylus" scoped>
.loader
  margin: 24px auto

  h1
    font-family: 'Oswald', sans-serif
    font-weight: normal
    font-size: 2.5rem
    text-align: center
    margin: 0

  h2
    font-family: 'Oswald', sans-serif
    font-weight: normal
    font-size: 1rem
    text-transform: uppercase
    margin: 0
    margin-top: -10px
    text-align: center
</style>
